The additional `Event`-specific criteria to filter by.
